import React from 'react'

import { isHTMLElement } from '@f-fertighaus/applications/Next/utils/typeguards/isHTMLElement'

const DEFAULT_CONTENT_OFFSET_PX = 300

const getOffsetTop = (ref: React.RefObject<HTMLElement>): number =>
  ref.current && isHTMLElement(ref.current.offsetParent)
    ? ref.current.offsetParent.offsetTop
    : DEFAULT_CONTENT_OFFSET_PX

export const useScrollToInitialHeight = <Element extends HTMLElement>(
  ref: React.RefObject<Element>
) => {
  const initialOffsetTop = React.useRef(0)

  React.useEffect(() => {
    if (ref.current) {
      initialOffsetTop.current = getOffsetTop(ref)
    }
  }, [ref])

  return React.useCallback(() => {
    const isBelowInitialPosition = getOffsetTop(ref) > initialOffsetTop.current

    if (isBelowInitialPosition) {
      const topScrollPosition = initialOffsetTop.current

      window.scrollTo({ top: topScrollPosition, behavior: 'smooth' })
    }
  }, [ref])
}
